import { Block } from 'factories/block';

export const focusBlockAction = (block: Block) => ({
  type: 'FOCUS_BLOCK',
  data: block,
});
